import { dataPuzzlePiece } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPuzzlePiece = /*#__PURE__*/createIcon(dataPuzzlePiece)
export default IconPuzzlePiece
